export default {
    generateContentModal: {
        title: 'Generer indhold',
        type: 'Type',
        typePlaceholder: 'Vælg type',
        typeEmptyError: 'Vælg venligst en type',
        context: 'Sammenhæng',
        contextPlaceholder: 'Vælg sammenhæng',
        contextEmptyError: 'Vælg venligst en sammenhæng',
        contentTitle: 'Indholdstitel',
        contentTitlePlaceholder: 'Tilføj temaet for dit indhold',
        contentTitleEmptyError: 'Indtast venligst titlen',
        contentTitleInvalidError: 'Indtast venligst den gyldige titel',
        contentTitleNumberError: 'Indtast venligst en titel, der begynder med et bogstav',
        description: 'Giv en kort indholdsbeskrivelse',
        descriptionPlaceholder: 'Tilføj beskrivelsen af ​​dit indhold i 2-3 linjer',
        descriptionEmptyError: 'Indtast venligst beskrivelsen',
        descriptionInvalidError: 'Indtast venligst en gyldig beskrivelse',
        addKeywords: 'Tilføj nøgleord',
        addKeywordsEmptyError: 'Indtast venligst nøgleordene',
        writingTone: 'Skrivetone',
        writingTonePlaceholder: 'Vælg skrivetone',
        writingToneEmptyError: 'Vælg venligst skrivetonen',
        numberOfVariations: 'Antal variationer',
        numberOfVariationsEmptyError: 'Vælg venligst antallet af variationer',
        numberOfVariationsInvalidError: 'Du kan maksimalt generere 5 og minimum 1 variation',
        generate: 'Generer',
        additionalOptions: 'Yderligere muligheder',
        clear: 'Ryd',
        writingToneOptions: {
            funny: 'Sjov',
            casual: 'Afslappet',
            excited: 'Begejstret',
            professional: 'Professionel',
            witty: 'Vittig',
            sarcastic: 'Sarkastisk',
            feminine: 'Feminin',
            masculine: 'Maskulin',
            bold: 'Fremhævet',
            dramatic: 'Dramatisk',
            grumpy: 'Gnaven',
            secretive: 'Hemmelighedsfuld',
            respectful: 'Respektfuld',
            persuasive: 'Overbevisende',
        },
        contextOptions: {
            promotional: 'Salgsfremmende',
            introduction: 'Introduktion',
            couponDiscount: 'Kupon/rabat',
            recurringNewsletter: 'Tilbagevendende nyhedsbrev',
            testimonial: 'Udtalelse',
            coldOutreach: 'Cold Outreach',
            contentGiveaway: 'Indhold/Giveaway',
            other: 'Andet',
        },
        typeOptions: {
            outline: 'Omrids',
            introduction: 'Introduktion',
            section: 'Afsnit',
        },
        customLengthOfContentPlaceholder: 'Antal ord (maks. 900)',
        lengthOfContentPlaceholder: 'Vælg indholdets længde',
        lengthOfContent: 'Indholdets længde',
        customLengthOfContent: 'Tilpasset længde',
        smallContent: 'Lille',
        mediumContent: 'Mellem',
        largeContent: 'Stor',
        customContentLength: 'Brugerdefineret længde (50 - 900 ord)',
        lengthOfContentError: 'Vælg venligst længden af indholdet',
        customLengthError: 'Forkert værdi',
        lengthOfContentTooltip: 'Indstil længden på indholdet, der vil blive genereret baseret på beskrivelsen af ​​opgaven',
    },
};
